import InfoIcon from '@material-ui/icons/Info';
import { useParams } from 'react-router-dom';
import Loading from '../../Components/Loading';
import StepIndicator from '../../Components/StepIndicator';
import Navigator from '../../Navigation/Navigator';
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import M from 'materialize-css';
import RegistrationPaymentPopup from './RegistrationPayment/Components/RegistrationPaymentPopup';
import { ReCaptcha, loadReCaptcha } from 'react-recaptcha-v3';
import { getUserInfoData } from 'pgdb-data-layer/lib/Redux/UserInfoRedux';
import { getToken } from '../../Session/SessionRedux';
import PaymentActions, { isFetchingFeeRequest, isOperationFailure, isFetchingPaymentUrl } from 'pgdb-data-layer/lib/Redux/PaymentRedux';
import { connect } from 'react-redux';
import * as ENDORSEMENT_HELPERS from 'pgdb-data-layer/lib/Helpers/Endorsement';
import { has } from 'lodash';
import RegistrationPaymentFailed from './RegistrationPayment/RegistrationPaymentFailed';
import './Endorsements/ApplyEndorsement.scss';
import './Endorsements/EndorsementPaymentStep.scss';
import { STEPS_ENDORSEMENT_FORM } from './EndorsementTypePage';
import EndorsementTimeLimitNotice from './Endorsements/EndorsementTimeLimitNotice';
import ApplicationsAction, {
   isSavingApplication,
   saveApplicationRequest,
   isFetchingApplicationSuccess,
   isFetchingApplication
} from 'pgdb-data-layer/lib/Redux/ApplicationsRedux';
import { APPLICATION_REASON_LATER, APPLICATION_STATUS_COMP } from 'pgdb-data-layer/lib/Constants/Application';
import EndorsementActions, { getEndorsement, isFetchingEndorsement } from 'pgdb-data-layer/lib/Redux/EndorsementRedux';
import LicenceActions, { getLicenceData, isFetchingLicence } from 'pgdb-data-layer/lib/Redux/LicenceRedux';
import * as REGISTRATION from 'pgdb-data-layer/lib/Constants/Registration';

const EndorsementPaymentPage = ({isLoading, paymentDetails, endorsementPayment, endorsement, putFeeRequest, patchApplication, getApplicationPayload, getPaymentUrlRequest, patchApplicationSuccess, token, userContactData, feeRequestError, isRenewal, activeEndorsementData, licences, getUserEndorsement, getLicences, patchApplicationPrivacyConsent}) => {
   const { applicationId } = useParams();

   const handleBack = () => {
      if (isRenewal) {
         Navigator.toRenewEndorsementTraining(applicationId);
      } else {
         Navigator.toEndorsementTraining(applicationId);
      }
   };

   const [isOpenInfo, setIsOpenInfo] = useState(false);
   const [recaptchaToken, setRecaptchaToken] = useState('');
   const [paymentResponse, setPaymentResponse] = useState(false);
   const [paymentFailed, setPaymentFailed] = useState(false);
   const [isPaymentFailedPopup, setIsPaymentFailedPopup] = useState(false);
   const [isPaidBefore, setIsPaidBefore] = useState(false);
   const [isPatching, setIsPatching] = useState(false);
   const [privacyConsentedManual, setPrivacyConsentedManual] = useState(false);
   const currentApp = endorsement.find(e => e.applicationId === parseInt(applicationId));
   const isPrivacyConsentLocked = !!(currentApp && currentApp.privacyStatementConsentedTimestamp);
   const privacyConsented = isPrivacyConsentLocked || privacyConsentedManual;
      
   useEffect(() => {
      loadReCaptcha(process.env.REACT_APP_RECAPTCHA_KEY);
   }, []);

   useEffect(() => {
      if (applicationId > 0) {
         putFeeRequest({ applicationId: applicationId, selectedOption: ENDORSEMENT_HELPERS.ENDORSEMENT_PAYMENT_TYPE }, token);
         getApplicationPayload(token, applicationId);
      }
   }, [token]);

   useEffect(() => {
      if (token && (!licences.currentLicences || licences.currentLicences.length === 0)) {
         getLicences(token);
      }
      if (token) {
         getUserEndorsement(token);
      }
   }, [token]);

   useEffect(() => {
      if (applicationId > 0 && endorsement.length > 0) {
         const currentEndorsement = endorsement.find(e => e.applicationId === parseInt(applicationId));
         if(currentEndorsement && currentEndorsement.feeRequestStatusCode === 'PAID') {
            setIsPaidBefore(true);
         }
      }
   }, [applicationId, endorsement]);
   
   const updateToken = () => {
      // you will get a new token in verifyCallback
      recaptchaToken.execute();
   };

   const verifyCallback = recaptchaToken => {
      setRecaptchaToken(recaptchaToken);
   };

   useEffect(() => {
      if (isPatching && patchApplicationSuccess) {
         if (isRenewal) {
            Navigator.toEndorsementRenewalSubmitSuccess();
         } else {
            Navigator.toEndorsementSubmitSuccess();
         }
      }
   }, [patchApplicationSuccess, isPatching]);

   useEffect(() => {
      if (paymentResponse && has(paymentDetails, 'isError')) {
         if (!paymentDetails.isError) {
            window.location = paymentDetails.response;
         } else {
            M.toast({
               html: `Sorry we couldn't process the payment.`,
               classes: 'error',
            });
            setPaymentFailed(true);
            displayPaymentFailedPopup();
            setPaymentResponse(false);
         }
      }
   }, [paymentDetails, paymentResponse]);
   
   const displayPaymentFailedPopup = () => {
      setIsPaymentFailedPopup(!isPaymentFailedPopup);
   };

   const displayPaymentPopup = () => {
      setIsOpenInfo(!isOpenInfo);
   };

   const getPolyPayment = () => {
      const routePrefix = isRenewal ? 'renew-endorsement' : 'apply-endorsement';
      const successPage = isRenewal ? 'endorsement-renewal-payment-success' : 'endorsement-payment-success';
      setPaymentResponse(true);
      getPaymentUrlRequest(
         {
            urlFail: `${window.location.origin.toString()}/${routePrefix}/${applicationId}/payment?payment-fail`,
            urlCancel: `${window.location.origin.toString()}/${routePrefix}/${applicationId}/payment?payment-fail`,
            urlSuccess: `${window.location.origin.toString()}/payment-success/${successPage}?paymentType=PoliPayment`,
            createLicence: false,
            contactId: userContactData.contactId,
            transactionType: isRenewal ? 'EndorsementRenewal' : 'Endorsement',
            paymentType: 'PoliPayment',
            applicationId: applicationId
         },
         recaptchaToken
      );
      displayPaymentPopup();
   };

   const getWindcavePayment = () => {
      const routePrefix = isRenewal ? 'renew-endorsement' : 'apply-endorsement';
      const successPage = isRenewal ? 'endorsement-renewal-payment-success' : 'endorsement-payment-success';
      setPaymentResponse(true);
      getPaymentUrlRequest(
         {
            urlFail: `${window.location.origin.toString()}/${routePrefix}/${applicationId}/payment?payment-fail`,
            urlSuccess: `${window.location.origin.toString()}/payment-success/${successPage}`,
            createLicence: false,
            contactId: userContactData.contactId,
            transactionType: 'Endorsement',
            applicationId: applicationId
         },
         recaptchaToken
      );
      displayPaymentPopup();
   };

   const computeEligibility = () => {
      if (!licences || !licences.currentLicences) {
         return { hasPlumber: false, hasDrainlayer: false };
      }

      const existingEndorsements = activeEndorsementData.endorsements || [];
      const activeCertifying = licences.currentLicences.filter(
         licence =>
            licence.status === 'Active' &&
            (licence.typeCode === REGISTRATION.CERTIFYING_PLUMBER_CODE ||
             licence.typeCode === REGISTRATION.CERTIFYING_DRAINLAYER_CODE)
      );

      const canRenewPlumber = existingEndorsements.some(e => e.endorsementTypeCode === ENDORSEMENT_HELPERS.ENDORSEMENT_TYPE_PLUMBER && e.canApplyForRenewal);
      const canRenewDrainlayer = existingEndorsements.some(e => e.endorsementTypeCode === ENDORSEMENT_HELPERS.ENDORSEMENT_TYPE_DRAINLAYER && e.canApplyForRenewal);
      const canApplyPlumber = activeCertifying.some(l => l.typeCode === REGISTRATION.CERTIFYING_PLUMBER_CODE) && !existingEndorsements.some(e => e.endorsementTypeCode === ENDORSEMENT_HELPERS.ENDORSEMENT_TYPE_PLUMBER);
      const canApplyDrainlayer = activeCertifying.some(l => l.typeCode === REGISTRATION.CERTIFYING_DRAINLAYER_CODE) && !existingEndorsements.some(e => e.endorsementTypeCode === ENDORSEMENT_HELPERS.ENDORSEMENT_TYPE_DRAINLAYER);

      if (isRenewal) {
         return {
            hasPlumber: canRenewPlumber || canApplyPlumber,
            hasDrainlayer: canRenewDrainlayer || canApplyDrainlayer,
         };
      }

      return {
         hasPlumber: canApplyPlumber,
         hasDrainlayer: canApplyDrainlayer,
      };
   };

   const renderEndorsementDescription = () => {
      const currentApp = endorsement.find(e => e.applicationId === parseInt(applicationId));
      const selectedTypeCodes = (currentApp && currentApp.endorsementTypeCodes) || [];

      if (selectedTypeCodes.length === 0) return null;

      const hasPlumberSelected = selectedTypeCodes.includes(ENDORSEMENT_HELPERS.ENDORSEMENT_TYPE_PLUMBER);
      const hasDrainlayerSelected = selectedTypeCodes.includes(ENDORSEMENT_HELPERS.ENDORSEMENT_TYPE_DRAINLAYER);

      const selectedNames = [
         ...(hasPlumberSelected ? ['Plumbing'] : []),
         ...(hasDrainlayerSelected ? ['Drainlaying'] : []),
      ];
      const selectedLabel = selectedNames.join(' and ');

      const eligibility = computeEligibility();
      const unselectedEligibleName = (!hasPlumberSelected && eligibility.hasPlumber)
         ? 'Plumbing'
         : (!hasDrainlayerSelected && eligibility.hasDrainlayer)
            ? 'Drainlaying'
            : null;

      return (
         <>
            <div className="table-clause-container">  
               <p>The following fees apply to your <b>{selectedLabel}</b> endorsement application.</p>
               {unselectedEligibleName && (
                  <p>These fees also cover <b>{unselectedEligibleName}</b> endorsement. You can apply for this at any time at no additional cost.</p>
               )}
            </div>
         </>
      );
   };

   const renderAmountTable = () => {
      return (
         <div>
            <table className="total-amount-container">
               <tbody>
                  <tr>
                     <td className="text first-row">{isRenewal ? 'Self-Certification renewal fee:' : 'Self-Certification application fee:'}</td>
                     <td className="amount">
                        {endorsementPayment.registrationTotalCost !== undefined
                           ? `NZD ${endorsementPayment.registrationTotalCost.toLocaleString('en-NZ', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`
                           : 0}
                     </td>
                  </tr>
                  {endorsementPayment.levy > 0 ? (
                     <tr>
                        <td className="text">Self-Certification audit levy:</td>
                        <td className="amount">{`NZD ${endorsementPayment.levy.toLocaleString('en-NZ', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`}</td>
                     </tr>
                  ) : null}
                  {endorsementPayment.discount > 0 ? (
                     <tr>
                        <td className="text">Waiver:</td>
                        <td className="amount">{`NZD ${endorsementPayment.discount.toLocaleString('en-NZ', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`}</td>
                     </tr>
                  ) : null}
                  <tr>
                     <td className="text last-row">Total balance to pay:</td>
                     <td className="amount">
                        {endorsementPayment.totalToBePaid !== undefined
                           ? `NZD ${endorsementPayment.totalToBePaid.toLocaleString('en-NZ', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`
                           : 0}
                     </td> 
                  </tr>
               </tbody>
            </table>
            <div className="table-clause-container">
               <p className="table-clause-text">{`* This amount incl. GST and excl. payment fees.`}</p>
            </div>
            <div className="fee-period-notice">
               <InfoIcon className="fee-period-notice__icon" fontSize="small" />
               <span>This fee covers a three-year endorsement period from the date of Board approval.</span>
            </div>
         </div>
      );
   };

   return (
      <main>
         <Loading isLoading={isLoading} overlayOnChildren={true}>
            <div className="section no-pad-bot" id="index-banner">
               <div className="container registration-container">
                  <div className="row no-margin flex">
                     <div className="col s10 m10 l10 offset-l1">
                        <div className="row profile-row">
                           <h4 className="columnheader">{isRenewal ? 'Endorsement Renewal' : 'Endorsement Application'}</h4>
                        </div>
                     </div>
                  </div>
               </div>
            </div>
            <StepIndicator steps={STEPS_ENDORSEMENT_FORM} currentStep={4} />
            <EndorsementTimeLimitNotice />
            <div className="section no-pad-bot endorsement-payment-container" id="index-banner">
               <div className="container">
                  <div className="row">
                     <div className="col s10 m10 l10 offset-l1">
                        { !isPaidBefore &&
                           <>
                              <b><p>Payment</p></b>
                              { renderEndorsementDescription() }
                              { feeRequestError && (
                                 <div className="card-panel red lighten-4">
                                    <span className="red-text text-darken-4">
                                       Sorry, we couldn't retrieve the payment details. Please try again later.
                                    </span>
                                 </div>
                              ) }
                              { renderAmountTable() }
                           </>
                        }
                        { isPaidBefore && (
                           <div>
                              <h5>No payment required</h5>
                              <p>You have already paid the endorsement application fee and audit levy for this endorsement period when you applied for your first endorsement.</p>
                              <p>You do not need to make another payment for this application.</p>
                           </div>
                        )}
                        <ReCaptcha
                           sitekey={process.env.REACT_APP_RECAPTCHA_KEY}
                           action="endorsement_payment"
                           verifyCallback={verifyCallback}
                        />
                        <div className="privacy-statement-notice">
                           <label>
                              <input type="checkbox" className="filled-in" checked={privacyConsented} onChange={e => setPrivacyConsentedManual(e.target.checked)} disabled={isPrivacyConsentLocked} />
                              <span>Please see our <a href="https://www.pgdb.co.nz/resources/website_privacy_statement/" target="_blank" rel="noopener noreferrer">Privacy Statement</a> to understand how we collect, use, share and store your personal information, including when we collect it from others or verify it with third parties, and how you can access and correct your personal information.</span>
                           </label>
                        </div>
                        <div className="row profile-row next-button-registration right">
                           <div className="navigate-buttons">
                              <button type="button" className="waves-light btn btn-inactive" onClick={handleBack}>
                                 Back
                              </button>
                              <button type="button" className="waves-light btn btn-inactive btn-ml-30" onClick={() => {
                                 if (privacyConsented && !isPrivacyConsentLocked) {
                                    patchApplicationPrivacyConsent(token, applicationId);
                                 }
                                 Navigator.toEndorsements();
                              }}>
                                 Save and Exit
                              </button>
                              { !isPaidBefore && 
                              (<button
                                 type="button"
                                 className="waves-effect waves-light btn btn-ml-30"
                                 onClick={() => {
                                    if (!isPrivacyConsentLocked) {
                                       patchApplicationPrivacyConsent(token, applicationId);
                                    }
                                    displayPaymentPopup();
                                 }}
                                 disabled={!recaptchaToken || feeRequestError || !privacyConsented}
                              >
                                 Pay
                              </button>)
                              }
                              { isPaidBefore && 
                                 ( <button
                                    type="button"
                                    className="waves-effect waves-light btn btn-ml-30"
                                    onClick={() => { setIsPatching(true); patchApplication(token, applicationId, { ApplicationStatusCode: APPLICATION_STATUS_COMP }); }}
                                 >
                                    Submit
                                 </button>)
                              }
                           </div>
                        </div>
                     </div>
                  </div>
               </div>

               <RegistrationPaymentPopup
                  onChange={displayPaymentPopup}
                  isModalOpen={isOpenInfo}
                  onWindcavePayment={getWindcavePayment}
                  onPolyPayment={getPolyPayment}
               />

               <RegistrationPaymentFailed
                  onChange={displayPaymentFailedPopup}
                  isModalOpen={isPaymentFailedPopup && paymentFailed}
               />
            </div>

         </Loading>
      </main>
   );
};


EndorsementPaymentPage.propTypes = {
   token: PropTypes.string.isRequired,
   isLoading: PropTypes.bool.isRequired,
   endorsement: PropTypes.array.isRequired,
   endorsementPayment: PropTypes.object.isRequired,
   userContactData: PropTypes.object.isRequired,
   putFeeRequest: PropTypes.func.isRequired,
   getPaymentUrlRequest: PropTypes.func.isRequired,
   getApplicationPayload: PropTypes.func.isRequired,
   feeRequestError: PropTypes.bool,
   patchApplication: PropTypes.func.isRequired,
   patchApplicationSuccess: PropTypes.bool.isRequired,
   activeEndorsementData: PropTypes.object.isRequired,
   licences: PropTypes.object.isRequired,
   getUserEndorsement: PropTypes.func.isRequired,
   getLicences: PropTypes.func.isRequired,
   isRenewal: PropTypes.bool,
};


const mapStateToProps = state => {
   const isLoading = isFetchingApplication("patchApplication", state) || isFetchingFeeRequest(state) || isFetchingApplication("getApplicationPayload", state) || isFetchingPaymentUrl(state) || isFetchingLicence(state) || isFetchingEndorsement('getUserEndorsement', state);
   return {
      isLoading: isLoading,
      token: getToken(state),
      userContactData: getUserInfoData(state.user),
      endorsementPayment: state.payment.registrationApplicationPayment,
      feeRequestError: isOperationFailure('putFeeRequest', state),
      paymentDetails: state.payment.paymentDetails,
      endorsement: state.application.payload.applications || [],
      patchApplicationSuccess: isFetchingApplicationSuccess('patchApplication', state) || false,
      activeEndorsementData: getEndorsement(state).endorsement,
      licences: getLicenceData(state),
   };
};

const mapDispatchToProps = {
   putFeeRequest: PaymentActions.putFeeRequest,
   getPaymentUrlRequest: PaymentActions.getPaymentUrlRequest,
   getApplicationPayload: ApplicationsAction.getApplicationPayloadRequest,
   patchApplication: ApplicationsAction.patchApplicationRequest,
   getUserEndorsement: EndorsementActions.getUserEndorsementRequest,
   getLicences: LicenceActions.licenceRequest,
   patchApplicationPrivacyConsent: ApplicationsAction.patchApplicationPrivacyConsentRequest,
};


export default connect(mapStateToProps, mapDispatchToProps)(EndorsementPaymentPage);
